import { createElement, Fragment } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export default function JsonLd({ data }: JsonLdProps) {
  return createElement(Fragment, null,
    createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: { __html: JSON.stringify(data) },
    })
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': 'https://infiniteconsultant.com/#organization',
    name: 'Infinite Consultant & Services',
    url: 'https://infiniteconsultant.com',
    logo: 'https://storage.readdy-site.link/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/f6da8d2f-add5-459f-af6f-e92fab0f29a7_compressed_logo-1.webp',
    image: 'https://storage.readdy-site.link/project_files/74591a0a-789e-4a59-949a-af227a1ed8cb/f6da8d2f-add5-459f-af6f-e92fab0f29a7_compressed_logo-1.webp',
    description: 'Complete property solutions in Bangalore — Landscaping, Interiors, Construction, Fabrication, Cleaning, Waterproofing, Branding, and Maintenance.',
    telephone: '+917019908718',
    email: 'infiniteconsultant2442@gmail.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'No.3, First Floor, RV Road, South End Circle',
      addressLocality: 'Bangalore',
      addressRegion: 'Karnataka',
      postalCode: '560011',
      addressCountry: 'IN',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '12.9416',
      longitude: '77.5731',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '19:00',
      },
    ],
    sameAs: [
      'https://www.facebook.com/infiniteconsultantandservices',
    ],
    priceRange: '₹₹',
    areaServed: {
      '@type': 'City',
      name: 'Bangalore',
    },
  };
}

export function getServiceSchema(name: string, description: string, serviceUrl: string, imageUrl?: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    provider: {
      '@type': 'LocalBusiness',
      '@id': 'https://infiniteconsultant.com/#organization',
    },
    url: serviceUrl,
    ...(imageUrl ? { image: imageUrl } : {}),
    areaServed: {
      '@type': 'City',
      name: 'Bangalore',
    },
  };
}

export function getFAQPageSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      '@id': 'https://infiniteconsultant.com/#website',
    },
  };
}